//
//
//
//

import Vue from 'vue'
import { debounce } from 'lodash'
import HtmlEditor from './HtmlEditor.vue'
const HtmlEditorClass = Vue.extend(HtmlEditor)

export default Vue.extend({
  components: { },

  props: {
    content: { type: String, default: null },
    variables: { type: Object, default: () => ({}) },
    delayEmit: { type: Number, default: 1000 }
  },

  data () {
    return {
      editors: {}
    }
  },

  created () {
    this.handleInput = debounce(this.handleInput, this.delayEmit)
  },

  mounted () {
    this.$refs.container.querySelectorAll('[data-editable]').forEach((el) => {
      const editableId = el.getAttribute('data-editable')
      this.editors[editableId] = new HtmlEditorClass({ propsData: { value: el.innerHTML, variables: this.variables, inputHandler: (input) => { this.handleInput(input, editableId) } } })
      this.editors[editableId].$mount(el)
    })
  },

  methods: {

    handleInput (value, editableId) {
      this.$emit('input', { value, editableId })
    }

  }

})
